'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { localStore } from 'utils/localStorage';

var Chat = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    shop: state.shops.shop
  };
}, (0, _extends3.default)({}, shopActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Chat, _Component);

  function Chat(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, Chat);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Chat.__proto__ || (0, _getPrototypeOf2.default)(Chat)).call(this, props));

    _this.handleLoadTiledesk = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var handle;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handle = _this.props.params.shopHandle;
              _context.next = 3;
              return _this.loadShop(handle);

            case 3:
              _this.injectChatScript();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.loadShop = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(handle) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.props.getShopData(handle);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.injectChatScript = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
      var _this$props$user, phone, name, email, userFullname, userEmail;

      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props$user = _this.props.user, phone = _this$props$user.phone, name = _this$props$user.profile.name, email = _this$props$user.email;
              userFullname = void 0, userEmail = void 0;

              if (!!email) {
                userEmail = email;
              } else {
                userEmail = phone + '@phone.lookme.vn';
              }
              userFullname = name || 'Guest';
              window.tiledeskSettings = {
                projectid: _this.props.shop._id,
                // departmentID: '5ece4e3eff4cfa41bc229505',
                customUserId: _this.props.user._id,
                userFullname: userFullname,
                userEmail: userEmail,
                isOpen: true,
                isShown: false,
                preChatForm: true,
                lang: 'vi'
              };
              (function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = process.env.TILEDESK_WIDGET_CHAT_URL;
                fjs.parentNode.insertBefore(js, fjs);
              })(document, 'script', 'tiledesk-jssdk');
              window.tileDeskAsyncInit = function () {
                window.tiledesk.on('loadParams', function (event) {
                  console.log('LOAD PARAM: ', event);
                });
                window.tiledesk.on('onLoggedIn', function (event) {
                  console.log('EVENT: ', event.detail);
                  _this.setState({ isLoading: false });
                });
                window.tiledesk.on('onClose', function () {
                  _this.props.history.goBack();
                });
              };

            case 7:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    _this.componentDidMount = function () {
      _this.handleLoadTiledesk();
    };

    _this.componentWillReceiveProps = function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(nextProps) {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(nextProps.params.shopHandle !== _this.props.shop.handle)) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return _this.loadShop(nextProps.params.shopHandle);

              case 3:
                window.tiledesk.reInit();

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.state = {
      isLoading: true
    };
    return _this;
  }

  (0, _createClass3.default)(Chat, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var handle = this.props.params.shopHandle;
      if (!handle) {
        this.props.history.goBack();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.tiledesk.logout();
    }
  }, {
    key: 'render',
    value: function render() {
      var isLoading = this.state.isLoading;

      if (isLoading) {
        return _react2.default.createElement(_components.Loading, null);
      }
      return null;
    }
  }]);
  return Chat;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  history: _react.PropTypes.object,
  shop: _react.PropTypes.object,
  location: _react.PropTypes.object,
  getShopData: _react.PropTypes.func,
  params: _react.PropTypes.object
}, _temp)) || _class);
exports.default = Chat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/AccountManagement/Chat.js
// module id = 1527
// module chunks = 0